import { Injectable, OnDestroy } from '@angular/core';

export interface toastMessage {
  message: string;
  delay: number;
  style: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService  {
  
  public toasts: toastMessage[] = [];
  
  constructor(
  ) {}

  public displayError(message: string, delay: number = 5000) {
    this.add(message, delay, 'bg-danger text-light');
  }

  public displaySuccess(message: string, delay: number = 5000) {
    this.add(message, delay, 'bg-success text-light');
  }

  public displayInfo(message: string, delay: number = 5000) {
    this.add(message, delay, 'bg-info text-light');
  }

  public add(message: string, delay: number = 5000, style: string = 'bg-info text-light') {
    this.toasts.push({ message, delay, style });
  }

  public remove(index: number) {
      this.toasts.splice(index, 1);
  }
}
